import { Prompt } from "./interfaces";

export const prompts: Prompt[] = [
  {
    text: "How do I manage my items?",
    children: [
      {
        text: "What do the status codes mean?",
        children: [],
      },
      {
        text: "How do I process a price change?",
        children: [],
      },
      {
        text: "How do I process a pack change?",
        children: [],
      },
      {
        text: "How do I discontinue an item?",
        children: [],
      },
      {
        text: "What items do not meet Food Traceability requirements?",
        children: [],
      },
    ],
  },
  {
    text: "What are my total sales?",
    children: [
      {
        text: "What report can I view my sales by item?",
        children: [],
      },
      {
        text: "What report can I view my fill rate by retailer?",
        children: [],
      },
      {
        text: "Where are my opportunities for growth?",
        children: [],
      },
    ],
  },
  {
    text: "What is my general item information?",
    children: [
      {
        text: "What are my product certificates?",
        children: [],
      },
      {
        text: "What are my delivery methods?",
        children: [],
      },
      {
        text: "What is my storage and shipping product information?",
        children: [],
      },
      {
        text: "Which items are currently active by DC?",
        children: [],
      },
      {
        text: "What is my KeHE Item Number by DC?",
        children: [],
      },
      {
        text: "Who is the Supply Chain buyer for my items?",
        children: [],
      },
    ],
  },
];

export const questionsRequiringFollowUp = [
  {
    userQuestion: "What are my product certificates?",
    followUp: "What is your UPC?",
  },
  {
    userQuestion: "What is my KeHE Item Number by DC?",
    followUp: "What is your UPC?",
  },
  {
    userQuestion: "Who is the Supply Chain buyer for my items?",
    followUp: "What is your ESN?",
  },
];
